export enum Environment {
    GlobalProfessionals = 'globalprofessionals',
    GloProps = 'glopros',
}
